import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
// import { verifyEmailwithToken } from '../../Apis/authApis';
import { axios } from "../../config";
import { authEndpoints } from "../../utils/constants/httpConstants";
import { CircularLoader, FullScreenLoader } from "../../components";
import EventEmitter from "../../utils/emitter/EventEmitter";
import { EMITTER_ERROR } from "../../utils/constants";
import { makeStyles } from "@mui/styles";
import {
  LOGIN_ANALYTICS_IMAGE,
  LOGIN_BACKGROUND,
  LOGIN_REACHIQ_LOGO,
} from "../../utils/constants/assets";
import { commonStyles } from "../../theme/globalStyles";
import {
  confirmPasswordvalidation,
  passwordValidation,
} from "../../utils/validations";
import ErrorMessage from "../../components/Messages/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword } from "../../redux/actions/authActions";
import { FORGOT_PASSWORD_PATH, LOGIN_PATH } from "../../utils/constants/routes";

const styles = makeStyles({
  container: {
    display: "grid",
    gridTemplateColumns: "3fr 2fr",
    "@media (max-width: 768px)": {
      display: "flex",
      flexDirection: "column",
    },
  },
  leftContainer: {
    // width: "60%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "10vh 16vw",
    background: "linear-gradient(120deg, #FFF1F1, transparent 40%)",
    "@media (max-width: 768px)": {
      width: "100%",
      height: "100vh",
    },
  },
  rightContainer: {
    width: "100%",
    background: `url(${LOGIN_BACKGROUND}) 0 0 no-repeat rgba(211, 218, 227, 0.2)`,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    backgroundSize: "cover",
    backgroundBlendMode: "multiply",
  },
  title: commonStyles.largeTitle,
  para: commonStyles.largePara,
  iconPara: {
    fontFamily: "inter_300",
    color: "#212833",
    alignSelf: "center",
    fontSize: "clamp(0.9rem,1vw,2.7rem)",
  },
  eachIconContainer: {
    display: "flex",
  },
  iconsContainer: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "0.5rem",
  },
  analyticsImage: {
    // width: "75%",
    // height: "100%",
    objectFit: "contain",
    marginTop: "1rem",
    "@media (max-width: 1500px)": {
      width: "90%",
    },
  },
  containAnalyticsImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    width: "clamp(80px,10vw,200px)",
    height: "clamp(80px,10vh,200px)",
    objectFit: "contain",
  },
  containLogo: {
    display: "flex",
    justifyContent: "center",
  },
  termsPara: {
    fontSize: "clamp(14px,1vw,42px)",
    color: "#626B7E",
    fontFamily: "inter_300",
    textAlign: "center",
  },

  containEachInput: {
    background: "#fcfcfd",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "0.5rem 1rem",
    border: "1px solid #D3DAE3",
    borderRadius: "8px",
    marginTop: "1rem",
  },
  eachInput: {
    border: "none",
    background: "#fcfcfd",
    fontFamily: "inter_700",
    fontSize: "clamp(14px,1vw,42px)",
  },
  eachInputTitle: {
    color: "#ABB4BD",
    fontFamily: "inter_400",
    fontSize: "clamp(14px,1vw,42px)",
  },

  loginBtn: commonStyles.redButtonWithShadow,
  flex: {
    display: "flex",
    justifyContent: "center",
  },

  containLoginBtn: {
    display: "flex",
    justifyContent: "center",
  },
  loginText: {
    color: "#ff4848",
    textAlign: "end",
    fontFamily: "inter_500",
    fontSize: "14px",
  },
});

const UpdatePasswordScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const resetPasswordSelector = useSelector((state) => state.resetPassword);
  const { loading, payload } = resetPasswordSelector;
  const classes = styles();
  const params = useParams();
  const [checking, setChecking] = useState(true);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validations, setValidations] = useState({
    password: "",
    confirmPassord: "",
  });

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    const validatedPassword = passwordValidation(password);
    const validatedComfirmPassword = confirmPasswordvalidation(
      password,
      confirmPassword
    );

    if (validatedPassword.isValid && validatedComfirmPassword.isValid) {
      setValidations({ password: "", confirmPassord: "" });
      const formdata = {
        verification_token: params.id,
        password: password,
      };
      await dispatch(resetPassword(formdata));
      navigate(LOGIN_PATH);
    } else {
      setValidations({
        password: validatedPassword.message,
        confirmPassord: validatedComfirmPassword.message,
      });
    }
  };

  useEffect(() => {
    if (payload) {
      setPassword("");
      setConfirmPassword("");
    }
    if (!password.length) {
      axios
        .post(authEndpoints.verifyTokenForResetPassword, {
          verification_token: params.id,
        })
        .then((response) => {
          // EventEmitter.emit(
          //     EMITTER_SUCCESS,response?.data?.message
          //   );
        })
        .catch((err) => {
          EventEmitter.emit(
            EMITTER_ERROR,
            err?.response?.data?.message + ",Please try again."
          );
          navigate(FORGOT_PASSWORD_PATH);
        })
        .finally(() => {
          setChecking(false);
        });
    }
  }, [payload]);

  return checking ? (
    <FullScreenLoader />
  ) : (
    <Box component="main" className={classes.container}>
      <Box className={classes.leftContainer}>
        <div className={classes.containLogo}>
          <img src={LOGIN_REACHIQ_LOGO} className={classes.logo} alt="" />
        </div>
        {/* Main auth form here */}
        <Box component="form" onSubmit={handleUpdatePassword} noValidate >
          <Box className={classes.containEachInput}>
            <span className={classes.eachInputTitle}>Password</span>
            <input
              className={classes.eachInput}
              type="password"
              placeholder="**********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Box>
          {validations.password && (
            <ErrorMessage message={validations.password} />
          )}

          <Box className={classes.containEachInput}>
            <span className={classes.eachInputTitle}>Confirm Password</span>
            <input
              className={classes.eachInput}
              type="password"
              placeholder="**********"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </Box>
          {validations.confirmPassord && (
            <ErrorMessage message={validations.confirmPassord} />
          )}

          <Box className={classes.containLoginBtn}>
            {loading ? (
              <CircularLoader />
            ) : (
              <button className={classes.loginBtn}>Reset Password</button>
            )}
          </Box>
        </Box>
        {/* Main auth form here */}
        <div>
          <p className={classes.termsPara}>
            2021 All Rights Reserved. Privacy and Terms.
          </p>
        </div>
      </Box>
      <Box className={classes.rightContainer}>
        <h3 className={classes.title}>FROM ITS MEDIVIAL ORIGINS</h3>
        <p className={classes.para}>
          Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in
          laying out print, graphic or web designs.
        </p>
        {/* <Box className={classes.iconsContainer}>
          <div className={classes.eachIconContainer}>
            <ImageIcon image={LOGIN_CROSS_ICON} />
            <p className={classes.iconPara}>No CC Required</p>
          </div>
          <div className={classes.eachIconContainer}>
            <ImageIcon image={LOGIN_CROSS_ICON} />
            <p className={classes.iconPara}>Cancel Anytime</p>
          </div>
          <div className={classes.eachIconContainer}>
            <ImageIcon image={LOGIN_CROSS_ICON} />
            <p className={classes.iconPara}>Free of cost</p>
          </div>
        </Box> */}
        <Box className={classes.containAnalyticsImage}>
          <img
            src={LOGIN_ANALYTICS_IMAGE}
            alt=""
            className={classes.analyticsImage}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default UpdatePasswordScreen;
